import { useParams, Navigate } from "react-router-dom";
import { getAvailablePlant } from "../util/helper/helperFunctions";

/* Guard component 
invalid plant code provided as the route 
it will re-directed to site selection */

const PlantGuard = ({ children }) => {
  const { plantCode } = useParams();
  return getAvailablePlant(plantCode) ? children : <Navigate to="/" replace />;
};

export default PlantGuard;
